<div class="d-flex famnuts-decoupage cursorHelp" *ngIf="!utils.isCollectionNullOrEmpty(cellule.famillesGemrcn)">
  <div class="no-overflow" [style.color]="getColor(cellule.famillesGemrcn)" [title]="tooltip()">{{label()}}</div>
</div>
